// extracted by mini-css-extract-plugin
export var orderSummary = "_qy-0";
export var showMoreLessButton = "_qy-1";